// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDY0wFdGHFfoM7jiudJ-hRaTXOQhRgIaME",
    authDomain: "mfigrupo.firebaseapp.com",
    databaseURL: "https://mfigrupo.firebaseio.com",
    projectId: "mfigrupo",
    storageBucket: "mfigrupo.appspot.com",
    messagingSenderId: "673038151485",
    appId: "1:673038151485:web:34a92195b5b97c67c61f54"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
